/*
 * App.js — ARGO
 */
import React, { useState, useEffect } from 'react';
import ArgoScreen       from './screens/ArgoScreen';
import ProductScreen    from './screens/ProductScreen';
import VideoScreen      from './screens/VideoScreen';
import View3DScreen     from './screens/View3DScreen';
import SuccessScreen    from './screens/SuccessScreen';
import { GlobalFonts }  from './screens/ARLanding.styles';
import './App.css';

/* Detect Zalo in-app browser */
function isZaloBrowser() {
  const ua = navigator.userAgent || '';
  return ua.includes('Zalo');
}

/* Redirect ra browser ngoài — iOS dùng Safari, Android dùng Chrome */
function redirectToExternalBrowser() {
  const url = window.location.href;
  const ua  = navigator.userAgent || '';
  const isAndroid = /android/i.test(ua);
  if (isAndroid) {
    const intent = `intent://${url.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
    window.location.href = intent;
  } else {
    window.location.href = url.replace(/^https?:\/\//, 'x-safari-https://');
  }
}

export default function App() {

  const [ screen, setScreen ]               = useState('argo');
  const [ activeProduct, setActiveProduct ] = useState(null);
  const [ autoStart, setAutoStart ]         = useState(false);

  useEffect(() => {
    if (isZaloBrowser()) {
      redirectToExternalBrowser();
    }
  }, []);

  const handleFound = (product, anchorIndex) => {
    console.log(`[App] Found anchor ${anchorIndex}, videoSrc:`, product.videoSrc);
    setActiveProduct(product);
    if (product.videoSrc) {
      setScreen('video');
    } else {
      setScreen('product');
    }
  };

  const handleBack = () => {
    setAutoStart(true);
    setScreen('argo');
    setActiveProduct(null);
  };

  const handleView3D = (product) => {
    setActiveProduct(product);
    setScreen('view3d');
  };

  return (
    <div className="app-root">
      <GlobalFonts />

      {screen === 'argo' && (
        <ArgoScreen onFound={handleFound} autoStart={autoStart} />
      )}

      {screen === 'product' && (
        <ProductScreen
          product={activeProduct}
          onBack={handleBack}
          onView3D={handleView3D}
        />
      )}

      {screen === 'video' && (
        <VideoScreen
          product={activeProduct}
          onBack={handleBack}
          onSuccess={() => setScreen('success')}
        />
      )}

      {screen === 'success' && (
        <SuccessScreen
          onHome={handleBack}
          onDesigns={() => { 
            window.location.href = 'https://pakgo.vn/bo-suu-tap/hop-trung-thu-2026'; 
          }}
        />
      )}

      {screen === 'view3d' && (
        <View3DScreen
          product={activeProduct}
          onBack={() => setScreen('product')}
        />
      )}
    </div>
  )
};
